import { render, staticRenderFns } from "./AddFrameModal.vue?vue&type=template&id=2ac8e686&scoped=true&"
import script from "./AddFrameModal.vue?vue&type=script&lang=js&"
export * from "./AddFrameModal.vue?vue&type=script&lang=js&"
import style0 from "./AddFrameModal.vue?vue&type=style&index=0&id=2ac8e686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac8e686",
  null
  
)

export default component.exports